import {
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Typography,
  } from "@material-ui/core";
  import React, { useEffect, useRef, useState } from "react";
  import { makeStyles } from "@material-ui/core";
  import { countOrACVFormatter, getUniqueValues, StyledTableRow } from "../../util/customFunctions";
  import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";
  import CopyTablesObjectv2 from "../../components/xlsx-export/CopyTablesObjectv2";
import { props } from "bluebird";
    
    const useStyles = makeStyles(
      (theme) => ({
        root: {
          margin: "0.5rem",
          padding: "0.5rem",
        },
        sticky: {
          position: "sticky",
          left: -1,
          background: "white",
          "&::after": {
            content: '""',
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            width: "0.5px",
            background: "lightgrey",
          },
        },
        colHeaderNew: {
          fontSize: "0.85rem",
          border: "0.5px solid lightgrey",
          padding: "7px 10px",
          color: "inherit",
          fontWeight: "inherit",
          backgroundColor: "inherit",
        },
        colHeader: {
          fontSize: "0.85rem",
          border: "0.5px solid lightgrey",
          padding: "7px 10px",
          color: "inherit",
          fontWeight: 600,
          cursor: "pointer",
        },
        dataCell: {
          fontSize: "0.85rem",
          border: "0.5px solid lightgrey",
          padding: "7px 10px",
          color: "inherit",
          fontWeight: "inherit",
          // width: '120px'
        },
        dataCell2: {
          fontSize: "0.85rem",
          border: "0.5px solid lightgrey",
          padding: "7px 10px",
          color: "inherit",
          fontWeight: "inherit",
        },
        drilldownCell: {
          fontSize: "0.85rem",
          border: "0.5px solid lightgrey",
          padding: "7px 10px",
          color: "inherit",
          fontWeight: "inherit",
          cursor: "pointer",
        },
        drilldownCellNQP: {
          fontSize: "0.85rem",
          border: "0.5px solid lightgrey",
          padding: "7px 10px",
          color: "inherit",
          width: "3%",
          fontWeight: "inherit",
          cursor: "pointer",
        },
        cellMargin: {
          fontSize: "0.85rem",
          border: "0.5px solid lightgrey",
          padding: "7px 10px",
          color: "inherit",
          fontWeight: "inherit",
          paddingLeft: "2rem",
        },
        fontBold: {
          fontWeight: 600,
        },
        indentName: {
          paddingLeft: 30,
        },
        noBorder: {
          border: "none",
        },
        primaryColumnColor: {
          backgroundColor: "#4472C4",
          color: "white",
        },
      }),
      { index: 1 }
    );
    
    function DataTable({ columns, data, dataTest, title, type, label, handleChangeLocation, mileStoneStage, logicalCols }) {
      const classes = useStyles();
      const tableRef = useRef();
      const tableContainerRef = useRef();
    
      const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
      const [isSticky, setIsSticky] = useState(false);
      const [rowPin, setrowPin] = useState(false);
      const [parentWidth, setparentWidth] = useState();
    
      const handleSort = (field) => {
        let direction = 'asc';
        if (sortConfig.key === field && sortConfig.direction === 'asc') {
          direction = 'desc';
        }
        setSortConfig({ key: field, direction });
      };

      const uniqueCols = data.map(f => f[type]).filter(getUniqueValues)
    
    //   const sortedData = React.useMemo(() => {
    //     if (!sortConfig.key) return data;

    
    //     return [...data].sort((a, b) => {
    //       let aValue = a[sortConfig.key];
    //       let bValue = b[sortConfig.key];
    
    //       // Handle null or undefined values
    //       aValue = aValue ?? '';
    //       bValue = bValue ?? '';
    
    //       // Numeric sorting
    //       if (typeof aValue === 'number' && typeof bValue === 'number') {
    //         return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
    //       }
    
    //       // Date sorting
    //       if (columns.find(col => col.field === sortConfig.key)?.type === 'date') {
    //         return sortConfig.direction === 'asc'
    //           ? new Date(aValue) - new Date(bValue)
    //           : new Date(bValue) - new Date(aValue);
    //       }
    
    //       // String sorting
    //       return sortConfig.direction === 'asc'
    //         ? aValue.toString().localeCompare(bValue.toString())
    //         : bValue.toString().localeCompare(aValue.toString());
    //     });
    //   }, [data, sortConfig, columns]);
  
    const sortedData = React.useMemo(() => {
        if (!sortConfig.key) return data;
      
        return [...data].sort((a, b) => {
          // Always put 'Total' at the end
          if (a[type] === 'Total') return 1;
          if (b[type] === 'Total') return -1;
      
          let aValue, bValue;
      
          if (sortConfig.key === type) {
            // Use index in logicalCols array to determine order
            aValue = logicalCols.indexOf(a[type]);
            bValue = logicalCols.indexOf(b[type]);
          } else {
            aValue = a[sortConfig.key];
            bValue = b[sortConfig.key];
          }
      
          aValue = aValue ?? '';
          bValue = bValue ?? '';
      
          // Numeric comparison
          if (typeof aValue === 'number' && typeof bValue === 'number') {
            return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
          }
      
          // Date comparison
          if (columns.find(col => col.field === sortConfig.key)?.type === 'date') {
            return sortConfig.direction === 'asc'
              ? new Date(aValue) - new Date(bValue)
              : new Date(bValue) - new Date(aValue);
          }
      
          // String comparison
          return sortConfig.direction === 'asc'
            ? aValue.toString().localeCompare(bValue.toString())
            : bValue.toString().localeCompare(aValue.toString());
        });
      }, [data, logicalCols, sortConfig, columns, type]);
      
      
      
    useEffect(() => {
        const tableContainer = tableContainerRef.current;
    
        const handleScroll = () => {
          if (tableContainer.scrollLeft > 0) {
            setIsSticky(true);
          } else {
            setIsSticky(false);
          }
          if (tableContainer.scrollTop > 0) {
            setrowPin(true);
          } else {
            setrowPin(false);
          }
        };
    
        tableContainer.addEventListener("scroll", handleScroll);
    
        return () => {
          tableContainer.removeEventListener("scroll", handleScroll);
        };
      }, [classes.sticky]);
  
        useEffect(() => {
          const parentWidth = tableContainerRef.current.getBoundingClientRect().width;
          setparentWidth(parentWidth);
        }, [parentWidth]);
    
      return (
        <div style={{ maxWidth: "100%", justifyContent: "center", padding: "2rem", paddingTop: 0 }}>
           <Grid container spacing={2} alignItems="center">
          <Grid item xs={11}>
            {/* <Typography align="center" variant={font} style={{fontWeight: 600 }}>
            White space at this account{data.length > 0 && `: ${countOrACVFormatter(data.map(f => f.List_price).reduce((a,b) => a+b, 0), true)}`}
            </Typography> */}
            <Typography align="left" variant='body2' style={{fontWeight: 600 }}>
            {title}
            </Typography>
          </Grid>
          <Grid item xs={1} style={{ textAlign: "right" }}>
            {parentWidth !== undefined && <CopyTablesObjectv2 tableRef={tableRef} />}
          </Grid>
        </Grid>
          <TableContainer
             style={{
              width: "auto",
              borderLeft: isSticky ? "0.5px solid lightgrey" : "",
              borderTop: rowPin ? "0.5px solid lightgrey" : "",
              maxHeight: "85vh",
              paddingBottom: '1rem'
            }}
            id="myTableContainer-Second"
            ref={tableContainerRef}
          >
            <Table ref={tableRef} data-test={dataTest}>
              <TableHead>
                <TableRow>
               
      {columns.map((col, idx) => (
         <TableCell
         key={idx}
         align="center"
         className={`${classes.sticky} ${classes.colHeader}`}
         style={{
           position: "sticky",
           top: 0,
           zIndex: 6,
           backgroundColor: "#4471c4",
           color: "white",
           width: col.label === "Product" ? "45rem" : undefined,
         }}
         sortDirection={sortConfig.key === col.field ? sortConfig.direction : false}
       >
         <TableSortLabel
           active={sortConfig.key === col.field}
           direction={sortConfig.key === col.field ? sortConfig.direction : "asc"}
           onClick={() => handleSort(col.field)}
           style={{ color: "white" }}
         >
           {col.label}
         </TableSortLabel>
       </TableCell>
      ))}
    </TableRow>
              </TableHead>
              <TableBody>
                {sortedData.map((row, idx) => (
                  <StyledTableRow key={idx}>
                    {columns.map((col, colIdx) => (
                      <TableCell key={colIdx} className={row[type] === 'Total' ? classes.colHeader : classes.dataCell} align={col.type === 'string' ? "left" : col.type === 'rank' ? 'center' : "right"}
                      style={{width: ['currency', 'perc'].includes(col.type) ? '200px' : undefined, 
                        cursor: ['acv', 'count', 'pipelineCreated'].includes(col.field) ? 'pointer' : 'default',
                    }}
                      onClick={['acv', 'count'].includes(col.field) ? () => handleChangeLocation('drilldownOnGraph', {
                        cell: row[type] === 'Total' ? 'Total' : typeof row[type] === 'string' ? [row[type]] : row[type]
                      }, type, 'won', label)
                       : 
                       ['pipelineCreated'].includes(col.field) ? () => handleChangeLocation('drilldownOnGraph', {
                        cell: row[type] === 'Total' ? 'Total' : typeof row[type] === 'string' ? [row[type]] : row[type]
                      }, type, 'qualified', label, mileStoneStage)
                       
                       : undefined}
                      >
                       {col.type === "currency" 
                                            ? countOrACVFormatter(row[col.field], true)
                                            :
                                            col.type === 'number' ?
                                            countOrACVFormatter(row[col.field], false)
                                            : col.type === "perc" ?
                                            `${Math.round((row[col.field] || 0) * 100)}%`
                                            : row[col.field] || " "}
                      </TableCell>
                    ))}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      );
    }
    
    export default DataTable;
    